import ErrorPage from 'Clutch/Organisms/ErrorPage'

function Custom404() {
  return <ErrorPage statusCode={404} />
}

export default Custom404
